import React from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Paper,
  Grid,
  TextField,
  Typography,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";

export default function StudentFormRow({
  student,
  onChange,
  class_list,
  sections,
}) {
  const form = useForm({
    defaultValues: student,
    mode: "onBlur",
  });

  const { control, handleSubmit, reset } = form;

  // Keep form in sync when props.student changes
  React.useEffect(() => {
    reset(student);
  }, [student, reset]);

  const handleBlur = () => {
    handleSubmit((data) => {
      onChange(student.student_id, data);
    })();
  };

  return (
    <Paper variant="elevation" sx={{ m: 2, p: 2 }}>
      {/* <Typography variant="h6">Student ID: {student.id}</Typography> */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <Controller
            name="admission_id"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                variant="standard"
                label="Admission Id"
                fullWidth
                onBlur={handleBlur}
                disabled={true}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Controller
            name="personal_details.name"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Name"
                variant="standard"
                fullWidth
                onBlur={handleBlur}
                disabled={true}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Controller
            name="class_id"
            control={control}
            render={({ field }) => (
              <FormControl variant="standard" fullWidth>
                <InputLabel>Class</InputLabel>
                <Select {...field} label="Class" onBlur={handleBlur}>
                  {class_list.map((classItem) => (
                    <MenuItem value={classItem.class_id}>
                      {classItem.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Controller
            name="section_id"
            control={control}
            render={({ field }) => (
              <FormControl variant="standard" fullWidth>
                <InputLabel>Section</InputLabel>
                <Select {...field} label="Section" onBlur={handleBlur}>
                  {sections.map((sectionItem) => (
                    <MenuItem value={sectionItem.section_id}>
                      {sectionItem.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Controller
            name="roll_number"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                variant="standard"
                label="Roll No"
                type="number"
                fullWidth
                onBlur={handleBlur}
              />
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
